import React, { useEffect, useState } from "react";
import "./FanEngagementTypeComponent.css";
import { useLocation, useNavigate } from "react-router-dom";
import { IoIosArrowRoundBack } from "react-icons/io";
import { APIUrl, APIUrlToken, getIsUser } from "../../Utils/Utils";
import axios from "axios";
import { FaUser } from "react-icons/fa";
import { FaPhoneAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { toast } from "react-toastify";

const FanEngagementTypeComponent = () => {
  const [step, setStep] = useState(1);
  const [selectedPlatform, setSelectedPlatform] = useState("");
  const [specialInstructions, setSpecialInstructions] = useState("");
  const [selectedPricing, setSelectedPricing] = useState("");
  const [multipleRequests, setMultipleRequests] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const {
    playerId,
    teamId,
    playerName,
    pricingOptionsList,
    dataFanExperience,
  } = location.state || {};
  const assignedAmount = location.state?.sectionValue;
  const [assignedAmountNav] = useState(assignedAmount);

  const engagementTypeFromNav = location.state?.type || "generalsupport";
  const [fanEngagementTypeNavigate] = useState(engagementTypeFromNav);
  const fanEngagementTypePay =
    location.state?.checkoutType || "sponsoredSocialMediaPost";
  const [brandEngagementTypeNavigate] = useState(fanEngagementTypePay);
  const [totalAmountCheckout, setTotalAmountCheckout] = useState("");

  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    phoneno: "",
    email: "",
  });
  // ---------------- Fan Experience Data -----------------

  useEffect(() => {}, [pricingOptionsList]);
  // ---------------- Dynamic Data Based on Type -----------------
  const selectedFanTypeData = dataFanExperience.find(
    (item) => item.fanEngagementType === fanEngagementTypeNavigate
  );

  const SocialMediaPlatform = selectedFanTypeData?.platforms || [];
  const FanEngagementDetails = {
    description: selectedFanTypeData?.description || "",
    example: selectedFanTypeData?.example || "",
    label: selectedFanTypeData?.specialInstructionsLabel || "Enter details:",
  };
  const PricingOptions = selectedFanTypeData?.pricingOptions || [];

  const CheckoutPayment = {
    description:
      "Include full name, review or edit selections, and checkout via credit card.",
  };

  const steps = [
    "Select Social Media Platform",
    "Provide Details of Fan Engagement",
    "Checkout Details & Payment",
  ];

  const nextStep = () => {
    if (step < steps.length) setStep(step + 1);
    if (step === 3) {
      handleSubmitFanEngagement();
    }
  };

  const prevStep = () => {
    if (step > 1) setStep(step - 1);
  };

  const handlePricingSelect = (option) => {
    setSelectedPricing(option);
    if (option !== "Multiple Requests (please specify)") {
      setMultipleRequests("");
    }
  };

  const progressWidth = `${(step / steps.length) * 100}%`;

  const isNextDisabled =
    (step === 1 && !selectedPlatform) ||
    (step === 2 && !specialInstructions.trim());

  const getStepContent = () => {
    switch (step) {
      case 1:
        return (
          <div className="fan-step">
            <h3>{steps[0]}</h3>
            <div className="fan-platforms">
              {SocialMediaPlatform.map((platform, index) => (
                <label key={index} className="fan-option">
                  <input
                    type="radio"
                    name="platform"
                    value={platform}
                    checked={selectedPlatform === platform}
                    onChange={(e) => setSelectedPlatform(e.target.value)}
                  />
                  <span>{platform}</span>
                </label>
              ))}
            </div>
          </div>
        );

      case 2:
        return (
          <div className="fan-step">
            <h3>{steps[1]}</h3>
            <p className="fan-description">
              {FanEngagementDetails.description}
            </p>
            <p className="fan-example">{FanEngagementDetails.example}</p>
            <div className="fan-field">
              <label>{FanEngagementDetails.label}</label>
              <textarea
                className="fan-input"
                placeholder="Enter any special instructions..."
                value={specialInstructions}
                onChange={(e) => setSpecialInstructions(e.target.value)}
              />
            </div>
          </div>
        );

      case 3:
        return (
          <div className="fan-step">
            <h3>{steps[2]}</h3>

            {/* ---------- Primary Details ---------- */}
            {!userLoginDetails?.user_id ? (
              <>
                <div className="section-title-accountInfo">Primary Details</div>
                <div className="first-section-my-profile">
                  <div className="input-section-accountInfo">
                    <div className="input-group-accountInfo">
                      <div className="input-icon-accountInfo">
                        <FaUser />
                      </div>
                      <input
                        type="text"
                        className="form-control-accountInfo"
                        name="firstname"
                        placeholder="First Name"
                        value={formData.firstname}
                        onChange={handleChange}
                        disabled={!!userLoginDetails?.user_id}
                      />
                    </div>
                  </div>

                  <div className="input-section-accountInfo">
                    <div className="input-group-accountInfo">
                      <div className="input-icon-accountInfo">
                        <FaUser />
                      </div>
                      <input
                        type="text"
                        className="form-control-accountInfo"
                        name="lastname"
                        placeholder="Last Name"
                        value={formData.lastname}
                        onChange={handleChange}
                        disabled={!!userLoginDetails?.user_id}
                      />
                    </div>
                  </div>

                  <div className="input-section-accountInfo">
                    <div className="input-group-accountInfo">
                      <div className="input-icon-accountInfo">
                        <FaPhoneAlt />
                      </div>
                      <input
                        type="text"
                        className="form-control-accountInfo"
                        name="phoneno"
                        placeholder="Phone Number"
                        value={formData.phoneno}
                        onChange={handleChange}
                        disabled={!!userLoginDetails?.user_id}
                      />
                    </div>
                  </div>

                  <div className="input-section-accountInfo">
                    <div className="input-group-accountInfo">
                      <div className="input-icon-accountInfo">
                        <MdEmail />
                      </div>
                      <input
                        type="text"
                        className="form-control-accountInfo"
                        name="email"
                        placeholder="Email"
                        value={formData.email}
                        onChange={handleChange}
                        disabled={!!userLoginDetails?.user_id}
                      />
                    </div>
                  </div>
                </div>
              </>
            ) : null}

            <hr />

            {/* ---------- Requested Details ---------- */}
            <div className="section-title-accountInfo">Requested Details</div>
            <div className="fetc-st4">
              <div>
                <strong>Fan Engagement Type:</strong>{" "}
                {brandEngagementTypeNavigate}
              </div>
              <div>
                <strong>Selected Platform:</strong> {selectedPlatform}
              </div>
              <div>
                <strong>Instructions for Athlete:</strong>{" "}
                {specialInstructions || "—"}
              </div>
              {multipleRequests && (
                <div>
                  <strong>Additional Requests:</strong> {multipleRequests}
                </div>
              )}
            </div>
            <hr />
            <div className="section-title-accountInfo">Pricing Details</div>
        <div className="fetc-st4">
  <div>
    <strong>Total:</strong>{" "}
    {(() => {
      const pricingValue = PricingOptions.find(
        (p) => p.pricingText === selectedPricing
      )?.pricingValue;

      // If value starts with "$", clean it
      if (typeof pricingValue === "string" && pricingValue.startsWith("$")) {
        return pricingValue.replace("+", "");
      }

      // Clean + from assignedAmountNav also (if it's a string)
      if (typeof assignedAmountNav === "string") {
        return assignedAmountNav.replace("+", "");
      }

      return assignedAmountNav;
    })()}
  </div>
</div>

            <hr />
          </div>
        );

      default:
        return null;
    }
  };
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  let userLoginDetails = getIsUser();

  const getNumericAmount = (value) => {
    if (!value) return 0;
    let str = String(value).trim();
    str = str.replace(/[^0-9.]/g, "");
    return Number(str) || 0;
  };

  const handleSubmitFanEngagement = () => {
    if (!userLoginDetails?.user_id) {
      if (!formData.firstname) {
        toast.error("Please enter firstname");
        return;
      }
      if (!formData.lastname) {
        toast.error("Please enter lastname");
        return;
      }
      if (!formData.phoneno) {
        toast.error("Please enter phoneno");
        return;
      }
      if (!formData.email) {
        toast.error("Please enter email");
        return;
      }
    }
    let data = {
      fan_engagement_type: fanEngagementTypeNavigate,
      social_media_platform: selectedPlatform,
      engagement_details: specialInstructions,
      message_to_athlete: multipleRequests,
      pricing_options: [
        {
          type: selectedPricing,
          amount: PricingOptions.find(
            (p) => p.pricingText === selectedPricing
          )?.pricingValue.startsWith("$")
            ? PricingOptions.find((p) => p.pricingText === selectedPricing)
                ?.pricingValue
            : assignedAmountNav,
        },
      ],
      user_id: userLoginDetails?.user_id,
      player_id: playerId,
    };
    if (userLoginDetails?.user_id) {
      data.user_id = userLoginDetails?.user_id;
      data.user_email = userLoginDetails?.user_email;
    } else {
      data.user_id = 0;
      data.user_first_name = formData.firstname;
      data.user_last_name = formData.lastname;
      data.user_phone_number = formData.phoneno;
      data.user_email = formData.email;
    }
    const url = `${APIUrl()}/v1/fan_engagement_request`;
    const option = {
      method: "POST",
      headers: {
        "X-API-Key": APIUrlToken(),
      },
      data: data,
      url: url,
    };

    axios(option)
      .then(async (response) => {
        const data = response?.data;
        // if (
        //   Number(
        //     PricingOptions?.find(
        //       (i) => i?.pricingText === selectedPricing
        //     )?.pricingValue?.split("$")?.[1]
        //   )
        // ) {
        await handleDonationOnetime(data?.fan_engagement_request_id);
        // } else {
        //   toast.success("Your request submitted Successfully");
        //   navigate("/dashboard/start-your-fan-experience");
        // }
      })
      .catch((error) => {
        console.error("Error fetching teams data:", error);
      });
  };
  const handleDonationOnetime = async (item) => {
    const priceOption = PricingOptions.find(
      (p) => p.pricingText === selectedPricing
    )?.pricingValue;

    const amountToSend =
      getNumericAmount(priceOption) || getNumericAmount(assignedAmountNav);

    let data = {
      amount: amountToSend,
      nil_service_type: "general_contribution",
      player_id: Number(playerId),
      player_name: playerName,
      team_id: Number(teamId),
      fan_engagement_request_id: item,
      brand_engagement_request_id: 0,
    };

    if (userLoginDetails?.user_id) {
      data.user_id = userLoginDetails?.user_id;
      data.user_email = userLoginDetails?.user_email;
    }

    try {
      const url = `${APIUrl()}/v1/create-checkout-session/one_time`;
      const response = await axios.post(url, data, {
        headers: { "X-API-Key": APIUrlToken() },
      });
      window.open(response?.data?.checkout_url, "_blank");
    } catch (error) {
      console.error("Error creating checkout session:", error);
    }
  };

  return (
    <>
      <div
        className="arrow-go-back-fan"
        onClick={() => {
          navigate(`/FanExperience/${playerId}/${teamId}`);
        }}
      >
        <IoIosArrowRoundBack />
        Go back to Fan Experience{" "}
      </div>
      <div className="fan-container">
        <div className="fan-progress-bar">
          <div className="fan-progress-fill" style={{ width: progressWidth }} />
        </div>

        <div className="fan-content">{getStepContent()}</div>

        <div className="fan-buttons">
          <button
            className="fan-btn fan-btn-prev"
            onClick={prevStep}
            disabled={step === 1}
          >
            Previous
          </button>
          <button
            className="fan-btn fan-btn-next"
            onClick={nextStep}
            disabled={isNextDisabled}
          >
            {step === steps.length ? "Proceed to Checkout" : "Next"}
          </button>
        </div>
      </div>
    </>
  );
};

export default FanEngagementTypeComponent;

// import React, { useEffect, useState } from "react";
// import "./FanEngagementTypeComponent.css";
// import { useLocation, useNavigate } from "react-router-dom";
// import { IoIosArrowRoundBack } from "react-icons/io";
// import { APIUrl, APIUrlToken, getIsUser } from "../../Utils/Utils";
// import axios from "axios";
// import { FaUser } from "react-icons/fa";
// import { FaPhoneAlt } from "react-icons/fa";
// import { MdEmail } from "react-icons/md";
// import { toast } from "react-toastify";
// const FanEngagementTypeComponent = () => {
//   const [step, setStep] = useState(1);
//   const [selectedPlatform, setSelectedPlatform] = useState("");
//   const [specialInstructions, setSpecialInstructions] = useState("");
//   const [selectedPricing, setSelectedPricing] = useState("");
//   const [multipleRequests, setMultipleRequests] = useState("");
//   const location = useLocation();
//   const navigate = useNavigate();
//   const { playerId, teamId, playerName, pricingOptionsList } =
//     location.state || {};
//   const assignedAmount = location.state?.sectionValue;
//   const [assignedAmountNav] = useState(assignedAmount);
//   const engagementTypeFromNav = location.state?.type || "generalsupport";
//   const [fanEngagementTypeNavigate] = useState(engagementTypeFromNav);
//   const fanEngagementTypePay =
//     location.state?.checkoutType || "sponsoredSocialMediaPost";
//   const [brandEngagementTypeNavigate] = useState(fanEngagementTypePay);
//   const [totalAmountCheckout, setTotalAmountCheckout] = useState("");

//   const [formData, setFormData] = useState({
//     firstname: "",
//     lastname: "",
//     phoneno: "",
//     email: "",
//   });
//   // ---------------- Fan Experience Data -----------------
//   const dataFanExperience = [
//     {
//       fanEngagementType: "generalSupport",
//       title: "General Support",
//       platforms: [
//         "Instagram",
//         "TikTok",
//         "Facebook",
//         "YouTube",
//         "X (Twitter)",
//         "LinkedIn",
//       ],
//       description: `${playerName} will support your channel by subscribing, following, liking content, or sharing your channel with their social media audience on the selected platform.

//         For example, if Instagram is selected as the platform and the athlete has over 15K followers, your content may be seen by their audience, helping expand your reach.`,
//       specialInstructionsLabel: "Special Instructions:",
//       pricingOptions: pricingOptionsList?.generalSupport?.options
//         ? pricingOptionsList?.generalSupport?.options
//         : [
//             {
//               pricingText: "Like ($25) per post",
//               pricingValue: "$25",
//             },
//             {
//               pricingText: "Follow/Subscribe ($25)",
//               pricingValue: "$25",
//             },
//             {
//               pricingText: "Comment ($75) per post",
//               pricingValue: "$75",
//             },
//             {
//               pricingText: "Share your channel ($150)",
//               pricingValue: "$150",
//             },
//             {
//               pricingText: "Multiple Requests (please specify)",
//               pricingValue: "custom",
//             },
//           ],
//     },
//     {
//       fanEngagementType: "personalizedPost",
//       title: "Personalized Post",
//       platforms: [
//         "Instagram",
//         "TikTok",
//         "Facebook",
//         "YouTube",
//         "X (Twitter)",
//         "LinkedIn",
//       ],
//       description: `${playerName} will post a personalized message (non-video) on your selected platform. Occasions may include: Birthday, Motivational, Congratulations, Holidays, or Other.

// For example, if Instagram is selected as the platform and the athlete has over 15K followers, your message will reach that audience, giving your post added visibility and engagement.`,
//       specialInstructionsLabel: "Create your custom message",
//       pricingOptions: pricingOptionsList?.personalizedPost?.options
//         ? pricingOptionsList?.personalizedPost?.options
//         : [
//             {
//               pricingText: "Under 50 words ($25)",
//               pricingValue: "$25",
//             },
//             {
//               pricingText: "50–100 words +$50",
//               pricingValue: "+${50}",
//             },
//             {
//               pricingText: "100–150 words +$75",
//               pricingValue: "+${75}",
//             },
//             {
//               pricingText: "Multiple Requests (please specify)",
//               pricingValue: "custom",
//             },
//           ],
//     },
//     {
//       fanEngagementType: "personalizedVideo",
//       title: "Personalized Video Message",
//       platforms: [
//         "Instagram",
//         "TikTok",
//         "Facebook",
//         "YouTube",
//         "X (Twitter)",
//         "LinkedIn",
//       ],
//       description: `${playerName} will record a personalized video message on your selected platform.

// For example, if Instagram is selected as the platform and the athlete has over 15K followers, your video message can be shared with that audience for greater visibility and engagement.

// Provide a topic or short instructions for the message.`,
//       specialInstructionsLabel: "Create custom video message",
//       pricingOptions: pricingOptionsList?.personalizedVideo?.options
//         ? pricingOptionsList?.personalizedVideo?.options
//         : [
//             {
//               pricingText: "Under 30 sec ($50)",
//               pricingValue: "$50",
//             },
//             {
//               pricingText: "30 sec–1 min +$50",
//               pricingValue: "+${50}",
//             },
//             {
//               pricingText: "Over 1 min (inquire)",
//               pricingValue: "inquire",
//             },
//             {
//               pricingText: "Multiple Requests (please specify)",
//               pricingValue: "custom",
//             },
//           ],
//     },
//     {
//       fanEngagementType: "meetGreet",
//       title: "Virtual Meet & Greet",
//       platforms: [
//         "Instagram",
//         "TikTok",
//         "Facebook",
//         "Twitch",
//         "YouTube",
//         "X (Twitter)",
//         "LinkedIn",
//         "Zoom",
//       ],
//       description: `Join ${playerName} in a virtual live session or video chat.
// Participate in Q&A sessions, polls, and interactive discussions.

// Details depend on availability. (${playerName} will send a notification with specific dates and times once confirmed.)

// *Tip: Encourage friends and fans to sign up as strong fan interest increases the chances of this live event happening!`,
//       specialInstructionsLabel: "",
//       pricingOptions: pricingOptionsList?.meetGreet?.options
//         ? pricingOptionsList?.meetGreet?.options
//         : [
//             {
//               pricingText: "15 min ($100)",
//               pricingValue: "$100",
//             },
//             {
//               pricingText: "30 min +$100",
//               pricingValue: "+${100}",
//             },
//             {
//               pricingText: "Over 30 min (inquire)",
//               pricingValue: "inquire",
//             },
//           ],
//     },
//     {
//       fanEngagementType: "personInteraction",
//       title: "In-Person Interaction",
//       platforms: [
//         "Autograph",
//         "Photo Opp",
//         "Meet & Greet",
//         "Fundraiser",
//         "Other",
//       ],
//       description: `${playerName} will attend in-person events such as autograph sessions, photo opportunities, or meet & greets.

// Details depend on availability. (${playerName} will send a notification with specific dates and times once confirmed.)

// *Tip: Encourage friends and fans to sign up as strong fan interest increases the chances of this in-person appearance!`,
//       specialInstructionsLabel: "",
//       pricingOptions: pricingOptionsList?.personInteraction?.options
//         ? pricingOptionsList?.personInteraction?.options
//         : [
//             {
//               pricingText: "5 min per person ($150)",
//               pricingValue: "$150",
//             },
//             {
//               pricingText: "Over 5 min (inquire)",
//               pricingValue: "inquire",
//             },
//           ],
//     },
//   ];
//   useEffect(() => {}, [pricingOptionsList]);
//   // ---------------- Dynamic Data Based on Type -----------------
//   const selectedFanTypeData = dataFanExperience.find(
//     (item) => item.fanEngagementType === fanEngagementTypeNavigate
//   );

//   const SocialMediaPlatform = selectedFanTypeData?.platforms || [];
//   const FanEngagementDetails = {
//     description: selectedFanTypeData?.description || "",
//     example: selectedFanTypeData?.example || "",
//     label: selectedFanTypeData?.specialInstructionsLabel || "Enter details:",
//   };
//   const PricingOptions = selectedFanTypeData?.pricingOptions || [];

//   const CheckoutPayment = {
//     description:
//       "Include full name, review or edit selections, and checkout via credit card.",
//   };

//   const steps = [
//     "Select Social Media Platform",
//     "Provide Details of Fan Engagement",
//     "Select Pricing Options",
//     "Checkout Details & Payment",
//   ];

//   const nextStep = () => {
//     if (step < steps.length) setStep(step + 1);
//     if (step === 4) {
//       handleSubmitFanEngagement();
//     }
//   };

//   const prevStep = () => {
//     if (step > 1) setStep(step - 1);
//   };

//   const handlePricingSelect = (option) => {
//     setSelectedPricing(option);
//     if (option !== "Multiple Requests (please specify)") {
//       setMultipleRequests("");
//     }
//   };

//   const progressWidth = `${(step / steps.length) * 100}%`;

//   const isNextDisabled =
//     (step === 1 && !selectedPlatform) ||
//     (step === 2 && !specialInstructions.trim()) ||
//     (step === 3 &&
//       (!selectedPricing ||
//         (selectedPricing === "Multiple Requests (please specify)" &&
//           multipleRequests.trim() === "")));

//   useEffect(() => {
//     const selectedOption = PricingOptions.find(
//       (p) => p.pricingText === selectedPricing
//     );

//     const assignedNum = Number(
//       String(assignedAmountNav || "").replace(/[^0-9.]/g, "")
//     );
//     const rawBase = (() => {
//       const assignedNum = Number(
//         String(assignedAmountNav || "").replace(/[^0-9.]/g, "")
//       );

//       if (!isNaN(assignedNum) && assignedNum > 0) {
//         return `$${assignedNum}`;
//       }
//       return (
//         pricingOptionsList?.config?.[fanEngagementTypeNavigate]?.sectionValue ||
//         "$25"
//       );
//     })();

//     const baseNum = Number(String(rawBase).replace(/[^0-9.]/g, ""));
//     const selectedValue = selectedOption?.pricingValue || "";
//     const selectedNum = Number(selectedValue.replace(/[^0-9.]/g, ""));
//     if (!selectedOption || !selectedNum) {
//       setTotalAmountCheckout(rawBase);
//       return;
//     }

//     // 1️⃣ PRIORITY: assignedAmountNav has valid number
//     if (!isNaN(assignedNum) && assignedNum > 0) {
//       const total = assignedNum + selectedNum;
//       setTotalAmountCheckout(`$${total}`);
//       return;
//     }

//     // 2️⃣ FALLBACK: assignedAmountNav invalid → use baseNum
//     const total = baseNum + selectedNum;
//     setTotalAmountCheckout(`$${total}`);
//   }, [
//     selectedPricing,
//     pricingOptionsList,
//     fanEngagementTypeNavigate,
//     assignedAmountNav,
//   ]);

//   const getStepContent = () => {
//     switch (step) {
//       case 1:
//         return (
//           <div className="fan-step">
//             <h3>{steps[0]}</h3>
//             <div className="fan-platforms">
//               {SocialMediaPlatform.map((platform, index) => (
//                 <label key={index} className="fan-option">
//                   <input
//                     type="radio"
//                     name="platform"
//                     value={platform}
//                     checked={selectedPlatform === platform}
//                     onChange={(e) => setSelectedPlatform(e.target.value)}
//                   />
//                   <span>{platform}</span>
//                 </label>
//               ))}
//             </div>
//           </div>
//         );

//       case 2:
//         return (
//           <div className="fan-step">
//             <h3>{steps[1]}</h3>
//             <p className="fan-description">
//               {FanEngagementDetails.description}
//             </p>
//             <p className="fan-example">{FanEngagementDetails.example}</p>
//             <div className="fan-field">
//               <label>{FanEngagementDetails.label}</label>
//               <textarea
//                 className="fan-input"
//                 placeholder="Enter any special instructions..."
//                 value={specialInstructions}
//                 onChange={(e) => setSpecialInstructions(e.target.value)}
//               />
//             </div>
//           </div>
//         );

//       case 3:
//         return (
//           <div className="fan-step">
//             <h3>{steps[2]}</h3>
//             <div className="fan-pricing">
//               {PricingOptions.map((option) => (
//                 <label key={option} className="fan-option fan-pricing-option">
//                   <input
//                     type="radio"
//                     name="pricing"
//                     value={option.pricingText}
//                     checked={selectedPricing === option.pricingText}
//                     onChange={() => handlePricingSelect(option.pricingText)}
//                   />
//                   <span>{option.pricingText}</span>
//                 </label>
//               ))}
//             </div>
//             {PricingOptions?.find((i) => i?.pricingText === selectedPricing)
//               ?.pricingValue === "custom" && (
//               <div className="fan-field fan-multi">
//                 <input
//                   type="text"
//                   className="fan-input"
//                   placeholder="Please specify your request..."
//                   value={multipleRequests}
//                   onChange={(e) => setMultipleRequests(e.target.value)}
//                 />
//               </div>
//             )}
//           </div>
//         );

//       case 4:
//         return (
//           <div className="fan-step">
//             <h3>{steps[3]}</h3>

//             {/* ---------- Primary Details ---------- */}
//             {!userLoginDetails?.user_id ? (
//               <>
//                 <div className="section-title-accountInfo">Primary Details</div>
//                 <div className="first-section-my-profile">
//                   <div className="input-section-accountInfo">
//                     <div className="input-group-accountInfo">
//                       <div className="input-icon-accountInfo">
//                         <FaUser />
//                       </div>
//                       <input
//                         type="text"
//                         className="form-control-accountInfo"
//                         name="firstname"
//                         placeholder="First Name"
//                         value={formData.firstname}
//                         onChange={handleChange}
//                         disabled={!!userLoginDetails?.user_id}
//                       />
//                     </div>
//                   </div>

//                   <div className="input-section-accountInfo">
//                     <div className="input-group-accountInfo">
//                       <div className="input-icon-accountInfo">
//                         <FaUser />
//                       </div>
//                       <input
//                         type="text"
//                         className="form-control-accountInfo"
//                         name="lastname"
//                         placeholder="Last Name"
//                         value={formData.lastname}
//                         onChange={handleChange}
//                         disabled={!!userLoginDetails?.user_id}
//                       />
//                     </div>
//                   </div>

//                   <div className="input-section-accountInfo">
//                     <div className="input-group-accountInfo">
//                       <div className="input-icon-accountInfo">
//                         <FaPhoneAlt />
//                       </div>
//                       <input
//                         type="text"
//                         className="form-control-accountInfo"
//                         name="phoneno"
//                         placeholder="Phone Number"
//                         value={formData.phoneno}
//                         onChange={handleChange}
//                         disabled={!!userLoginDetails?.user_id}
//                       />
//                     </div>
//                   </div>

//                   <div className="input-section-accountInfo">
//                     <div className="input-group-accountInfo">
//                       <div className="input-icon-accountInfo">
//                         <MdEmail />
//                       </div>
//                       <input
//                         type="text"
//                         className="form-control-accountInfo"
//                         name="email"
//                         placeholder="Email"
//                         value={formData.email}
//                         onChange={handleChange}
//                         disabled={!!userLoginDetails?.user_id}
//                       />
//                     </div>
//                   </div>
//                 </div>
//               </>
//             ) : null}

//             <hr />

//             {/* ---------- Requested Details ---------- */}
//             <div className="section-title-accountInfo">Requested Details</div>
//             <div className="fetc-st4">
//               <div>
//                 <strong>Fan Engagement Type:</strong>{" "}
//                 {brandEngagementTypeNavigate}
//               </div>
//               <div>
//                 <strong>Selected Platform:</strong> {selectedPlatform}
//               </div>
//               <div>
//                 <strong>Instructions for Athlete:</strong>{" "}
//                 {specialInstructions || "—"}
//               </div>
//               {multipleRequests && (
//                 <div>
//                   <strong>Additional Requests:</strong> {multipleRequests}
//                 </div>
//               )}
//             </div>

//             <hr />

//             {/* ---------- Pricing Details ---------- */}
//             <div className="section-title-accountInfo">Pricing Details</div>
//             {/* <div className="fetc-st4">
//               <div>
//                 <strong>Selected Option:</strong> {selectedPricing}
//               </div>
//               <div>
//                 <strong>Amount:</strong>{" "}
//                 {PricingOptions.find(
//                   (p) => p.pricingText === selectedPricing
//                 )?.pricingValue.startsWith("$")
//                   ? PricingOptions.find(
//                       (p) => p.pricingText === selectedPricing
//                     )?.pricingValue
//                   : "Custom / Inquire"}{" "}
//                 {pricingOptionsList?.[fanEngagementTypeNavigate]?.sectionValue
//                   ? `+ ${pricingOptionsList?.[fanEngagementTypeNavigate]?.sectionValue}`
//                   : ` + $25`}
//               </div>
//             </div> */}
//             <div className="fetc-st4">
//               <div>
//                 <strong>Selected Option:</strong> {selectedPricing}
//               </div>
//               <div>
//                 <strong>Amount:</strong>{" "}
//                 {(() => {
//                   const selectedOption = PricingOptions.find(
//                     (p) => p.pricingText === selectedPricing
//                   );
//                   if (!selectedOption) return "Custom / Inquire";
//                   const selectedValue = selectedOption.pricingValue;
//                   const baseAmount = (() => {
//                     const assignedNum = Number(
//                       String(assignedAmountNav || "").replace(/[^0-9.]/g, "")
//                     );
//                     if (!isNaN(assignedNum) && assignedNum > 0) {
//                       return `$${assignedNum}`;
//                     }
//                     return (
//                       pricingOptionsList?.config?.[fanEngagementTypeNavigate]
//                         ?.sectionValue || "$25"
//                     );
//                   })();
//                   return `${selectedValue} + ${baseAmount}`;
//                 })()}
//               </div>
//               <div>
//                 <strong>Total:</strong> {totalAmountCheckout}
//               </div>
//             </div>

//             <hr />
//           </div>
//         );

//       default:
//         return null;
//     }
//   };
//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value,
//     });
//   };
//   let userLoginDetails = getIsUser();
//   const handleSubmitFanEngagement = () => {
//     if (!userLoginDetails?.user_id) {
//       if (!formData.firstname) {
//         toast.error("Please enter firstname");
//         return;
//       }
//       if (!formData.lastname) {
//         toast.error("Please enter lastname");
//         return;
//       }
//       if (!formData.phoneno) {
//         toast.error("Please enter phoneno");
//         return;
//       }
//       if (!formData.email) {
//         toast.error("Please enter email");
//         return;
//       }
//     }
//     let data = {
//       fan_engagement_type: fanEngagementTypeNavigate,
//       social_media_platform: selectedPlatform,
//       engagement_details: specialInstructions,
//       message_to_athlete: multipleRequests,
//       pricing_options: [
//         {
//           type: selectedPricing,
//           amount: PricingOptions?.find(
//             (i) => i?.pricingText === selectedPricing
//           )?.pricingValue,
//         },
//       ],
//       user_id: userLoginDetails?.user_id,
//       player_id: playerId,
//     };
//     if (userLoginDetails?.user_id) {
//       data.user_id = userLoginDetails?.user_id;
//       data.user_email = userLoginDetails?.user_email;
//     } else {
//       data.user_id = 0;
//       data.user_first_name = formData.firstname;
//       data.user_last_name = formData.lastname;
//       data.user_phone_number = formData.phoneno;
//       data.user_email = formData.email;
//     }
//     const url = `${APIUrl()}/v1/fan_engagement_request`;
//     const option = {
//       method: "POST",
//       headers: {
//         "X-API-Key": APIUrlToken(),
//       },
//       data: data,
//       url: url,
//     };

//     axios(option)
//       .then(async (response) => {
//         const data = response?.data;
//         if (
//           Number(
//             PricingOptions?.find(
//               (i) => i?.pricingText === selectedPricing
//             )?.pricingValue?.split("$")?.[1]
//           )
//         ) {
//           await handleDonationOnetime(data?.fan_engagement_request_id);
//         } else {
//           toast.success("Your request submitted Successfully");
//           navigate("/dashboard/start-your-fan-experience");
//         }
//       })
//       .catch((error) => {
//         console.error("Error fetching teams data:", error);
//       });
//   };
//   const handleDonationOnetime = async (item) => {
//     const numericAmount = Number(totalAmountCheckout.replace("$", ""));
//     let data = {
//       amount: numericAmount,
//       nil_service_type: "general_contribution",
//       player_id: Number(playerId),
//       player_name: playerName,
//       team_id: Number(teamId),
//       fan_engagement_request_id: item,
//       brand_engagement_request_id: 0,
//     };

//     if (userLoginDetails?.user_id) {
//       data.user_id = userLoginDetails?.user_id;
//       data.user_email = userLoginDetails?.user_email;
//     }

//     const url = `${APIUrl()}/v1/create-checkout-session/one_time`;
//     const option = {
//       method: "POST",
//       headers: {
//         "X-API-Key": APIUrlToken(),
//       },
//       data: data,
//       url: url,
//     };

//     axios(option)
//       .then((response) => {
//         const data = response?.data?.checkout_url || [];
//         window.open(data, "_blank");
//       })
//       .catch((error) => {
//         console.error("Error fetching teams data:", error);
//       });
//   };

//   return (
//     <>
//       <div
//         className="arrow-go-back-fan"
//         onClick={() => {
//           navigate(`/FanExperience/${playerId}/${teamId}`);
//         }}
//       >
//         <IoIosArrowRoundBack />
//         Go back to Fan Experience{" "}
//       </div>
//       <div className="fan-container">
//         <div className="fan-progress-bar">
//           <div className="fan-progress-fill" style={{ width: progressWidth }} />
//         </div>

//         <div className="fan-content">{getStepContent()}</div>

//         <div className="fan-buttons">
//           <button
//             className="fan-btn fan-btn-prev"
//             onClick={prevStep}
//             disabled={step === 1}
//           >
//             Previous
//           </button>
//           <button
//             className="fan-btn fan-btn-next"
//             onClick={nextStep}
//             disabled={isNextDisabled}
//           >
//             {step === steps.length ? "Proceed to Checkout" : "Next"}
//           </button>
//         </div>
//       </div>
//     </>
//   );
// };

// export default FanEngagementTypeComponent;
